import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToEstateAgentsForm } from '@shared/components/forms/estate-agents'
import { Section } from '@shared/components/section'
import CbLogo from '@shared/svg/cb-logo.svg'
import NewSkolkovoLogo from '@shared/svg/new-skolkovo.svg'

import styles from './style.module.scss'

export const View = () => {
	return (
		<Section fullWidth className={styles.wrap}>
			<div className={styles.content}>
				<h4 className={styles.title}>О нас</h4>
				<div>
					Credit.Club — платформа цифровых решений для кредитования. Мы разрабатываем сервисы и
					приложения, которые упрощают доступ к финансовым услугам. Наша цель — делать кредиты
					доступными, развивая технологии для всех участников рынка. <br /> <br /> Команда
					Credit.Club работает с 2012 года.
				</div>
			</div>
			<div className={styles.info}>
				<div className={styles.logos}>
					<a
						style={{ display: 'contents' }}
						href='https://www.cbr.ru/'
						target='_blank'
						rel='noopener noreferrer nofollow'
					>
						<CbLogo className={styles.cbrf} />
					</a>
					<a
						style={{ display: 'contents' }}
						href='https://sk.ru/'
						target='_blank'
						aria-label='Перейти на сайт Sk.ru'
						rel='noopener noreferrer nofollow'
					>
						<span className='visually-hidden'>Перейти на сайт Sk.ru</span>
						<NewSkolkovoLogo className={styles.skolkovo} />
					</a>
				</div>
				<div className={styles.infoText}>
					ООО «Кредит.Клаб» — участник проекта инновационного центра «Сколково». Мы предоставляем
					цифровой сервис для удобного получения кредитов{' '}
					<div style={{ whiteSpace: 'nowrap' }}>
						(
						<button onClick={scrollToEstateAgentsForm} className={styles.link}>
							более подробно
						</button>
						).
					</div>
				</div>
			</div>
			<div className={styles.product}>
				<h4 className={styles.productTitle}>
					Повлияйте <br /> на развитие продукта
				</h4>
				<div className={styles.productText}>
					К концу 2022 году мы планируем построить большую площадку для риелторов
					с&nbsp;автоматизированными&nbsp;сервисами для комфортной работы. То, какой она будет, во
					многом зависит от вас.
				</div>
				<Button onClick={scrollToEstateAgentsForm} className={styles.productButton}>
					Оставить заявку
				</Button>
			</div>
		</Section>
	)
}
